import { styled } from 'styled-components';
import { Box } from '@mui/material';

const StyledCodeSnippet = styled(Box)`
  background-color: #1e1e1e;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 1.5rem;
  overflow-x: auto;
  max-width: 100%;

  pre {
    margin: 0;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.875rem;
    line-height: 1.6;
    color: #d4d4d4;

    code {
      color: #d4d4d4;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  @media (max-width: 425px) {
    padding: 1rem;

    pre {
      font-size: 0.75rem;
    }
  }
`;

export default StyledCodeSnippet;
